import EthereumNetwork from '@providers/EthereumNetwork'
import PolygonNetwork from '@providers/PolygonNetwork'
import { IAbiItem } from '@types'

export interface IHandleMintAllowed {
    mintAllowed: number
}

export const handleMintAllowed = async (
    provider: EthereumNetwork | PolygonNetwork,
    contractAbi: IAbiItem[],
    contractAdress: string,
    position: number,
): Promise<IHandleMintAllowed> => {
    const web3 = provider.getCurrentProvider()
    const Ticket = provider.getWeb3Contract(contractAbi, contractAdress)

    const account = await provider.getCurrentAccount()
    const mintAllowed = await Ticket.methods.getMintedByAddress(account[0], web3.utils.toBN(position)).call()

    return { mintAllowed }
}
